<template>
  <main v-if="canSeePage">
    <article class="row">
      <section class="col s4 left-align" style="margin-top: 15px;">
        <strong>Email:</strong>
        <a :href="`mailto:${analyst.email}`"
           target="_blank"
        >
          {{ analyst.email }}
        </a>
        <br>
        <strong>Slack:</strong>
        <a :href="isFarmTeamer ? `https://app.slack.com/client/T8PPLKX2R/C8R1QHKHQ/user_profile/${analyst.slack_id}`
                               : `https://app.slack.com/client/T024FSPSL/C04UL7CLW/user_profile/${analyst.slack_id}`"
           target="_blank"
        >
          #{{ analyst.first_name }}
        </a>
      </section>
      <section class="col s4">
        <h4>
          <strong>{{ analyst.name }}</strong>
        </h4>
      </section>
      <section class="col s4">
        <img :src="analyst.avatar">
      </section>
    </article>
    <article class="row">
      <section class="col s8">
        <activity-feed :analyst-id="analystId" />
      </section>
      <section class="col s4">
        <article class="row">
          <section class="col s12">
            &nbsp;
          </section>
        </article>
        <article class="row">
          <section class="col s12">
            <mini-ratings :analyst-id="analystId" />
          </section>
        </article>
      </section>
    </article>
  </main>
  <main v-else>
    <article class="container">
      <h4>
        Analyst
        <span class="pink-text strong">{{ analystId }}</span>
        is not accessible
      </h4>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import ActivityFeed from '@/components/ActivityFeed.vue';
import MiniRatings from '@/components/MiniRatings.vue';

export default {
  name: 'Analyst',
  components: { ActivityFeed, MiniRatings },
  props: {},
  data() {
    return {
      analyst: {
        roles: [],
      },
    };
  },
  computed: {
    analystId() {
      return Number(this.$route.query.analyst_id);
    },
    isFarmTeamer() {
      return this.analyst.roles.includes('farm-team');
    },
    canSeePage() {
      return this.$auth.hasRoles('analyst', 'adp') ||
        this.isFarmTeamer;
    },
  },
  watch: {},
  methods: {},
  async mounted() {
    const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/analyst/?analyst_id=${this.analystId}`);
    this.analyst = data;
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

img {
  border: 1px solid $tmf-gains;
  border-radius: 10px;
  height: 75px;
}
</style>
